jQuery(function($) {
    'use strict';

    var popupsHash = {};
    var template = '<div id="%id%" class="popup">' +
        '    <div class="popup-body">' +
        '        <span class="popup-exit"></span>' +
        '        <div class="popup-content">' +
        '            <div class="popup-window__title">' +
        '                %title%' +
        '            </div>' +
        '            <div class="popup-window__subheading">' +
        '                %subheading%' +
        '            </div>' +
        '            <div class="popup-window__container">' +
        '               %content%' +
        '            </div>' +
        '        </div>' +
        '    </div>' +
        '</div>';

    var $popupOverlay = $('.popup-overlay').eq(0);
    $popupOverlay.on('click', _onOverlayClick);
    $popupOverlay.on('click', '.popup-exit, .popup-window__cancel', _handleClose);

    function _onOverlayClick(e) {
        if (e.target === e.currentTarget) {
            _closeAllPopups();
        }
    }

    function _handleClose(e) {
        /*jshint validthis: true */
        e.preventDefault();
        e.stopPropagation();
        
        var $popup = $(this).closest('.popup');
        _closePopup($popup.attr('id'));
    }

    /**
     * @param {object} options {id: 'random', title: null, subheading: null, content: null}
     * @return jQuery.Deferred
     * @private
     */
    function _openPopup(options) {
        var popupOptions = $.extend(
            {
                id: 'popup',
                title: null,
                subheading: null,
                content: null,
            },
            options
        );

        if (!popupOptions.content) {
            console.warn('\'content\' property is empty.');
            return;
        }

        var markup = template
            .replace(/%id%/g, popupOptions.id)
            .replace(/%title%/g, popupOptions.title)
            .replace(/%subheading%/g, popupOptions.subheading)
            .replace(/%content%/g, popupOptions.content);
        var $markup = $(markup);

        if (!popupOptions.title) {
            $markup.find('.popup-window__title').remove();
        }

        if (!popupOptions.subheading) {
            $markup.find('.popup-window__subheading').remove();
        }

        // close existing popup with the same id
        if (popupsHash[popupOptions.id]) _closePopup(popupOptions.id);

        $popupOverlay.append($markup);
        $('html').addClass('overlay');
        $popupOverlay.css('display', 'block');

        popupsHash[popupOptions.id] = {
            instance: $markup,
            options: popupOptions,
        };

        return $markup;
    }

    function _closePopupOverlay() {
        $('html').removeClass('overlay');
        $popupOverlay.css('display', 'none');
        $popupOverlay.empty();
    }

    function _closePopup(id) {
        if (id && popupsHash[id].instance) {
            var $instance = popupsHash[id].instance;
            delete popupsHash[id];
            $instance.trigger('close');
            $instance.remove();
        }

        // only close overlay when no popup is open
        if (Object.keys(popupsHash).length > 0) return;

        _closePopupOverlay();
    }

    function _closeAllPopups() {
        for (var id in popupsHash) {// jshint ignore:line
            _closePopup(id);
        }

        _closePopupOverlay();
    }

    window.popup = {
        open: _openPopup,
        close: _closePopup,
        closeAllPopups: _closeAllPopups,
    };
});
